import {errorsObject, keysToSnakeCase} from '@myxplor/payload-helpers'
import * as types from './constants'

export const handlePending = () => {
  return {
    loading: true
  }
}

export const handleFailed = (action) => {
  return {
    loading: false,
    errors: errorsObject(action.errors)
  }
}

export const handleSuccess = (action) => {
  return Object.assign(
    {
      loading: false,
      valid: true,
    },
    {attributes: keysToSnakeCase(action.attributes)}
  )
}

export const defaultState = {
  attributes: {},
  errors: {},
  loading: false,
  valid: false
}

export default (state = defaultState, action) => {
  switch (action.type) {
  case types.REGISTRATION_PROCESSING:
    return Object.assign(
      {},
      state,
      handlePending()
    )

  case types.REGISTRATION_FAILED:
    return Object.assign(
      {},
      state,
      handleFailed(action)
    )
  
  case types.REGISTRATION_SUCCESSFUL:
    return Object.assign(
      {},
      state,
      handleSuccess(action)
    )
  
  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/registration/reducer.js